import { ReactNode } from 'react';

interface ButtonSetProps {
  className?: string;
  padTop?: boolean;
  children: ReactNode;
}

export default function ButtonSet({ className = '', padTop, children }: ButtonSetProps) {
  if (padTop) {
    className += ' pt-4';
  }

  return (
    <div className={`button-set ${className}`.trim()}>
      {children}
    </div>
  );
}
